export default __webpack_public_path__ + "img/f177038a9d2c23880ffe8d046fe4af9a.svg";